import { MenuItem } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useGlobalTimeSliderContext } from '../../../context/contexts';
import { now } from '../../../date/date-utils';
import { Menu } from './Menu';
import { TimeSliderGranularity } from './types';

const StyledMenuItem = styled(MenuItem)`
  &.Mui-selected {
    background-color: rgb(0, 150, 153);
  }
`;

const menuLabel = (label: string) => `common:timeSlider.steps.${label}`;

export const GranularityPicker = () => {
  const { t } = useTranslation();
  const timeSliderHandle = useGlobalTimeSliderContext();
  const [timeSliderState, dispatch] = timeSliderHandle;

  return (
    <Menu label={t(menuLabel(timeSliderState.selectedGranularity.label))}>
      {timeSliderState.granularities.map(
        (granularity: TimeSliderGranularity) => (
          <StyledMenuItem
            key={`granularity-picker-${granularity.id}`}
            selected={timeSliderState.selectedGranularity.id === granularity.id}
            onClick={() =>
              dispatch({
                type: 'update-granularity',
                granularity,
                current: now(),
              })
            }
            style={{ color: 'inherit' }}
          >
            {t(menuLabel(granularity.label))}
          </StyledMenuItem>
        )
      )}
    </Menu>
  );
};
